import React, { useState } from "react";
import ProductArea from "./NavigationProductArea";
import ApplicationArea from "./NavigationApplicationArea";
import ProductCategory from "./NavigationProductCategory";
import NavigationAllProducts from "./Navigation/NavigationAllProducts";

const NavigationList = ({ menuItem }) => {
    const viewAllProductsLink = window.__SHARED__.ViewAllProductsLink;

    /*
  const [open, setOpen] = useState(false);
  const [openItemId, setOpenItemId] = useState("");
  
  const toggleOpen = (id) => {
    setOpenItemId(id);
    if (openItemId === id) return setOpenItemId("");
  };

  const toggleList = () => {
    setOpen(!open);
  };
  */

    if (menuItem.ProductAreas && menuItem.ProductAreas.Children) {
        return (
            <li className={`nav-item mx-2 root dropdown megamenu  ${menuItem.IsActive ? "active" : ""}`}>
                <a
                    className={`nav-link dropdown-toggle ${menuItem.IsActive ? "active" : ""}`}
                    href={menuItem.Url}
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    {menuItem.DisplayName}
                </a>

                {/* Dropdown Menu */}
                <div aria-labelledby="megamenu" className="dropdown-menu">
                    {/* The tabs */}
                    <div className="row">
                        <div className="col-lg-12">
                            <ul className="nav nav-list level1 flex-row text-center" id="myTab" role="tablist">
                                {menuItem.ProductCategories?.Children?.length > 0 && (
                                    <li className="col nav-item">
                                        <a
                                            className="nav-link active"
                                            id="tab-B"
                                            data-bs-toggle="tab"
                                            href="#pane-B"
                                            role="tab"
                                            aria-controls="pane-B"
                                            aria-selected="false"
                                        >
                                            {menuItem.ProductCategories.DisplayName}
                                        </a>
                                    </li>
                                )}

                                <li className="col nav-item">
                                    <a
                                        className="nav-link"
                                        id="tab-A"
                                        data-bs-toggle="tab"
                                        href="#pane-A"
                                        role="tab"
                                        aria-controls="pane-A"
                                        aria-selected="true"
                                    >
                                        {menuItem.ProductAreas.DisplayName}
                                    </a>
                                </li>

                                {menuItem.ApplicationAreas?.Children?.length > 0 && (
                                    <li className="col nav-item">
                                        <a
                                            className="nav-link"
                                            id="tab-C"
                                            data-bs-toggle="tab"
                                            href="#pane-C"
                                            role="tab"
                                            aria-controls="pane-C"
                                            aria-selected="false"
                                        >
                                            {menuItem.ApplicationAreas.DisplayName}
                                        </a>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>

                    {/* Tab content */}
                    <div className="row">
                        <div className="col-lg-12 p-0">
                            <div className="tab-content" id="TabContent" role="tablist">
                                {/* Product Categories */}
                                {menuItem.ProductCategories?.Children?.length > 0 && (
                                    <div
                                        id="pane-B"
                                        className="tab-pane fade show active"
                                        role="tabpanel"
                                        aria-labelledby="tab-B"
                                    >
                                        <div className="tab-header" role="tab" id="heading-B">
                                            <h5 className="my-1 mx-4">
                                                <a
                                                    className="btn btn-primary dropdown-toggle"
                                                    data-bs-toggle="collapse"
                                                    href="#collapse-B"
                                                    aria-expanded="false"
                                                    aria-controls="collapse-B"
                                                >
                                                    {menuItem.ProductCategories.DisplayName}
                                                </a>
                                            </h5>
                                        </div>
                                        <div
                                            id="collapse-B"
                                            className="collapse show"
                                            data-bs-parent="#TabContent"
                                            role="tabpanel"
                                            aria-labelledby="heading-B"
                                        >
                                            <ul className="nav row no-gutters product-categories">
                                                <ProductCategory items={menuItem.ProductCategories.Children} />
                                            </ul>
                                        </div>
                                    </div>
                                )}

                                {/* Product Areas */}
                                <div id="pane-A" className="tab-pane fade" role="tabpanel" aria-labelledby="tab-A">
                                    <div className="tab-header" role="tab" id="heading-A">
                                        <h5 className="my-1 mx-4">
                                            <a
                                                className="btn btn-primary dropdown-toggle"
                                                data-bs-toggle="collapse"
                                                href="#collapse-A"
                                                aria-expanded="true"
                                                aria-controls="collapse-A"
                                            >
                                                {menuItem.ProductAreas.DisplayName}
                                            </a>
                                        </h5>
                                    </div>
                                    <div
                                        id="collapse-A"
                                        className="collapse"
                                        data-bs-parent="#TabContent"
                                        role="tabpanel"
                                        aria-labelledby="heading-A"
                                    >
                                        <ul className="nav row no-gutters">
                                            <ProductArea items={menuItem.ProductAreas.Children} />
                                        </ul>
                                    </div>
                                </div>

                                {/* Application Areas */}
                                {menuItem.ApplicationAreas?.Children?.length > 0 && (
                                    <div id="pane-C" className="tab-pane fade" role="tabpanel" aria-labelledby="tab-C">
                                        <div className="tab-header" role="tab" id="heading-C">
                                            <h5 className="my-1 mx-4">
                                                <a
                                                    className="btn btn-primary dropdown-toggle"
                                                    data-bs-toggle="collapse"
                                                    href="#collapse-C"
                                                    aria-expanded="false"
                                                    aria-controls="collapse-C"
                                                >
                                                    {menuItem.ApplicationAreas.DisplayName}
                                                </a>
                                            </h5>
                                        </div>

                                        <div
                                            id="collapse-C"
                                            className="collapse"
                                            data-bs-parent="#TabContent"
                                            role="tabpanel"
                                            aria-labelledby="heading-C"
                                        >
                                            <NavigationAllProducts items={menuItem.ApplicationAreas.Children} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        );
    } else {
        return (
            <li className={`nav-item mx-2 root ${menuItem.IsActive ? "active" : ""}`}>
                <a className={`nav-link ${menuItem.IsActive ? "active" : ""}`} href={menuItem.Url}>
                    {menuItem.DisplayName}
                </a>
            </li>
        );
    }
};

export default NavigationList;
